<template>
  <div class="dynamic-property-fields-C">
    <h4
      style="margin-bottom: 12px; color: #336; font-weight: bold; width: 100%;"
    >
      Dinamik Özellikler
    </h4>
    <!-- Debug: PropertyDefinitions Data -->
    <div
      v-if="
        showDebugInfo && propertyDefinitions && propertyDefinitions.length > 0
      "
      style="margin-right: 12px; padding: 8px; background: #f0f0f0; border: 1px solid #ccc; border-radius: 4px; width: 100%; margin-bottom: 12px;"
    >
      <label
        style="display: block; font-weight: bold; margin-bottom: 4px; color: #666;"
        >DEBUG - Gelen Veri ({{ propertyDefinitions.length }} adet):</label
      >
      <pre
        style="margin: 0; padding: 8px; background: white; border: 1px solid #ddd; border-radius: 3px; font-size: 11px; overflow-x: auto; max-height: 200px; overflow-y: auto;"
        >{{ JSON.stringify(propertyDefinitions, null, 2) }}</pre
      >
    </div>
    <!-- Dinamik Özellikler -->
    <template v-for="propDef in propertyDefinitions" :key="propDef.id">
      <!-- Dropdown (Single) -->
      <div
        v-if="propDef.displayType === 3 && propDef.cardinality === 1"
        class="dynamic-property-C"
        style="margin-right: 12px;"
      >
        <span
          style="display: inline-block; padding: 2px 6px; background: #e3f2fd; color: #1976d2; border-radius: 3px; font-size: 10px; font-weight: bold; margin-bottom: 4px;"
          >Dropdown (Single)</span
        >
        <r-select
          v-model="propertyValues[propDef.id]"
          :label="propDef.name"
          :data="propDef.values || []"
          txt="displayText"
          val="id"
          width="180px"
          @change="onSelectChange(propDef.id, $event)"
          :disabled="isLoading"
        />
      </div>
      <!-- Dropdown (Multiple) - Dropdown ile multiple seçim için CheckboxList kullan -->
      <div
        v-else-if="propDef.displayType === 3 && propDef.cardinality === 2"
        class="dynamic-property-C"
        style="margin-right: 12px;"
      >
        <span
          v-if="showDebugInfo"
          style="display: inline-block; padding: 2px 6px; background: #e3f2fd; color: #1976d2; border-radius: 3px; font-size: 10px; font-weight: bold; margin-bottom: 4px;"
          >Dropdown (Multiple)</span
        >
        <label
          style="display: block; margin-bottom: 4px; font-size: 12px; color: #666;"
          >{{ propDef.name }}</label
        >
        <div
          v-if="propDef.values && propDef.values.length > 0"
          style="display: flex; flex-wrap: wrap; gap: 8px;"
        >
          <r-checkbox
            v-for="val in propDef.values"
            :key="`${propDef.id}-${val.id}`"
            v-model="propertyMultipleValues[propDef.id]"
            :val="val.id"
            :label="val.displayText || val.value"
            @change="e => onPropertyMultipleChange(propDef.id, val.id, e)"
            :disabled="isLoading"
          />
        </div>
        <div
          v-else
          style="padding: 8px; background: #fff3cd; border: 1px solid #ffc107; border-radius: 3px; color: #856404; font-size: 11px;"
        >
          ⚠ Seçenek bulunamadı (values boş)
        </div>
      </div>
      <!-- CheckboxList (Multiple) -->
      <div
        v-else-if="propDef.displayType === 4 && propDef.cardinality === 2"
        class="dynamic-property-C"
        style="margin-right: 12px;"
      >
        <span
          style="display: inline-block; padding: 2px 6px; background: #fff3e0; color: #e65100; border-radius: 3px; font-size: 10px; font-weight: bold; margin-bottom: 4px;"
          >CheckboxList (Multiple)</span
        >
        <label
          style="display: block; margin-bottom: 4px; font-size: 12px; color: #666;"
          >{{ propDef.name }}</label
        >
        <div
          v-if="propDef.values && propDef.values.length > 0"
          style="display: flex; flex-wrap: wrap; gap: 8px;"
        >
          <r-checkbox
            v-for="val in propDef.values"
            :key="`${propDef.id}-${val.id}`"
            v-model="propertyMultipleValues[propDef.id]"
            :val="val.id"
            :label="val.displayText || val.value"
            @change="e => onPropertyMultipleChange(propDef.id, val.id, e)"
            :disabled="isLoading"
          />
        </div>
        <div
          v-else
          style="padding: 8px; background: #fff3cd; border: 1px solid #ffc107; border-radius: 3px; color: #856404; font-size: 11px;"
        >
          ⚠ Seçenek bulunamadı (values boş)
        </div>
      </div>
      <!-- CheckboxList (Single) - RadioButton gibi davran -->
      <div
        v-else-if="propDef.displayType === 4 && propDef.cardinality === 1"
        class="dynamic-property-C"
        style="margin-right: 12px;"
      >
        <span
          style="display: inline-block; padding: 2px 6px; background: #fff3e0; color: #e65100; border-radius: 3px; font-size: 10px; font-weight: bold; margin-bottom: 4px;"
          >CheckboxList (Single)</span
        >
        <label
          style="display: block; margin-bottom: 4px; font-size: 12px; color: #666;"
          >{{ propDef.name }}</label
        >
        <div
          v-if="propDef.values && propDef.values.length > 0"
          style="display: flex; flex-wrap: wrap; gap: 8px;"
        >
          <r-checkbox
            v-for="val in propDef.values"
            :key="val.id"
            :modelValue="propertyValues[propDef.id] === val.id"
            :val="val.id"
            :label="val.displayText || val.value"
            @change="() => onSingleCheckboxChange(propDef.id, val.id)"
            :disabled="isLoading"
          />
        </div>
        <div
          v-else
          style="padding: 8px; background: #fff3cd; border: 1px solid #ffc107; border-radius: 3px; color: #856404; font-size: 11px;"
        >
          ⚠ Seçenek bulunamadı (values boş)
        </div>
      </div>
      <!-- RadioButton (Single) - Dropdown olarak göster -->
      <div
        v-else-if="propDef.displayType === 5 && propDef.cardinality === 1"
        class="dynamic-property-C"
        style="margin-right: 12px;"
      >
        <span
          style="display: inline-block; padding: 2px 6px; background: #f3e5f5; color: #7b1fa2; border-radius: 3px; font-size: 10px; font-weight: bold; margin-bottom: 4px;"
          >RadioButton (Single)</span
        >
        <r-select
          v-model="propertyValues[propDef.id]"
          :label="propDef.name"
          :data="propDef.values || []"
          txt="displayText"
          val="id"
          width="180px"
          @change="onSelectChange(propDef.id, $event)"
          :disabled="isLoading"
        />
      </div>
      <!-- TextBox -->
      <div
        v-else-if="propDef.displayType === 1"
        class="dynamic-property-C"
        style="margin-right: 12px;"
      >
        <span
          style="display: inline-block; padding: 2px 6px; background: #e8f5e9; color: #2e7d32; border-radius: 3px; font-size: 10px; font-weight: bold; margin-bottom: 4px;"
          >TextBox</span
        >
        <r-input
          v-model="propertyCustomValues[propDef.id]"
          :label="propDef.name"
          width="180px"
          @blur="
            () =>
              onPropertyChange(
                propDef.id,
                null,
                propertyCustomValues[propDef.id]
              )
          "
          :disabled="isLoading"
        />
      </div>
      <!-- TextArea -->
      <div
        v-else-if="propDef.displayType === 2"
        class="dynamic-property-C"
        style="margin-right: 12px;"
      >
        <span
          style="display: inline-block; padding: 2px 6px; background: #e8f5e9; color: #2e7d32; border-radius: 3px; font-size: 10px; font-weight: bold; margin-bottom: 4px;"
          >TextArea</span
        >
        <r-textarea
          v-model="propertyCustomValues[propDef.id]"
          :label="propDef.name"
          width="180px"
          @blur="
            () =>
              onPropertyChange(
                propDef.id,
                null,
                propertyCustomValues[propDef.id]
              )
          "
          :disabled="isLoading"
        />
      </div>
      <!-- NumberInput -->
      <div
        v-else-if="propDef.displayType === 6"
        class="dynamic-property-C"
        style="margin-right: 12px;"
      >
        <span
          style="display: inline-block; padding: 2px 6px; background: #fff9c4; color: #f57f17; border-radius: 3px; font-size: 10px; font-weight: bold; margin-bottom: 4px;"
          >NumberInput</span
        >
        <r-input
          v-model.number="propertyCustomValues[propDef.id]"
          type="number"
          :label="propDef.name"
          width="180px"
          @blur="
            () =>
              onPropertyChange(
                propDef.id,
                null,
                propertyCustomValues[propDef.id]
              )
          "
          :disabled="isLoading"
        />
      </div>
      <!-- BooleanCheckbox -->
      <div
        v-else-if="propDef.displayType === 8"
        class="dynamic-property-C"
        style="margin-right: 12px;"
      >
        <span
          style="display: inline-block; padding: 2px 6px; background: #fce4ec; color: #c2185b; border-radius: 3px; font-size: 10px; font-weight: bold; margin-bottom: 4px;"
          >BooleanCheckbox</span
        >
        <r-checkbox
          v-model="propertyCustomValues[propDef.id]"
          :label="propDef.name"
          @change="
            () =>
              onPropertyChange(
                propDef.id,
                null,
                propertyCustomValues[propDef.id] ? 'true' : 'false'
              )
          "
          :disabled="isLoading"
        />
      </div>
      <!-- Fallback: Eğer hiçbir koşul eşleşmezse -->
      <div
        v-else
        style="margin-right: 12px; padding: 8px; background: #ffcccc; border: 2px solid red; border-radius: 4px;"
      >
        <strong style="color: red;">FALLBACK - Koşul Eşleşmedi:</strong>
        <small style="display: block; margin-top: 4px;">
          {{ propDef.name }}<br />
          displayType: {{ propDef.displayType }}<br />
          cardinality: {{ propDef.cardinality }}<br />
          values count: {{ propDef.values ? propDef.values.length : 0 }}
        </small>
      </div>
    </template>
  </div>
</template>

<script>
/* eslint-disable */
import { ref, watch, onMounted, computed, reactive } from 'vue'
import { useStore } from 'vuex'

export default {
	name: 'DynamicPropertyFields',
	props: {
		questionId: {
			type: Number,
			required: true
		},
		isLoading: {
			type: Boolean,
			default: false
		}
	},
	setup(props) {
		const store = useStore()
		const propertyDefinitions = ref([])
		const propertyValues = ref({}) // Single value properties: { propertyDefId: valueId }
		const propertyMultipleValues = reactive({}) // Multiple value properties: { propertyDefId: [valueId1, valueId2] } - reactive kullanıyoruz
		const propertyCustomValues = ref({}) // Custom text/number values: { propertyDefId: "custom text" }
		const internalLoading = ref(false)
		
		// Debug modunu kontrol etmek için: Browser console'dan showDebugInfo.value = true/false ile kontrol edilebilir
		const showDebugInfo = ref(false)
		
		// Çift tetiklemeyi önlemek için guard flag
		const isProcessingMultipleChange = ref(false)

		const getPropertyDefinitions = async () => {
			try {
				// Önce aktif property definitions'ları çek
				const res = await store.dispatch('getDatas', { api: 'PropertyDefinitions/active' })
				const arr = res && (res.data ?? res.Data)
				const definitions = arr != null ? arr : []
				
				// Her property definition için detail endpoint'ini çağırarak values'ları da çek
				const definitionsWithValues = await Promise.all(
					definitions.map(async (def) => {
						try {
							const detailRes = await store.dispatch('getDatas', { api: `PropertyDefinitions/${def.id}/detail` })
							if (detailRes && detailRes.result && detailRes.data) {
								// Detail'den gelen values'ları kullan
								return {
									...def,
									values: detailRes.data.values || detailRes.data.propertyDefinitionValues || []
								}
							}
							// Fallback: aktif endpoint'ten gelen values'ları kullan
							return def
						} catch (err) {
							console.warn(`[WARN] Failed to fetch detail for property ${def.id}:`, err)
							return def
						}
					})
				)
				
				propertyDefinitions.value = definitionsWithValues
				
				// Her multiple cardinality property için başlangıçta boş array initialize et
				definitionsWithValues.forEach(propDef => {
					if (propDef.cardinality === 2) {
						if (!propertyMultipleValues[propDef.id]) {
							propertyMultipleValues[propDef.id] = []
						}
					}
				})
				
				return definitionsWithValues
			} catch (error) {
				console.error('[ERROR] Failed to fetch property definitions:', error)
				propertyDefinitions.value = []
				return []
			}
		}

		const getQuestionProperties = async (questionId) => {
			if (!questionId) return
			try {
				const res = await store.dispatch('getDatas', { api: `QuestionProperties/question/${questionId}` })
				const arr = res && (res.data ?? res.Data)
				const questionProperties = Array.isArray(arr) ? arr : []
				
				// Mevcut property değerlerini form'a yükle
				propertyValues.value = {}
				// Reactive object için key'leri temizle
				Object.keys(propertyMultipleValues).forEach(key => delete propertyMultipleValues[key])
				propertyCustomValues.value = {}
				
				questionProperties.forEach(qp => {
					const propDefId = qp.propertyDefinitionId
					const propDef = propertyDefinitions.value.find(pd => pd.id === propDefId)
					
					if (qp.propertyDefinitionValueId) {
						// Single value property
						if (propertyValues.value[propDefId]) {
							// Multiple cardinality için array'e çevir
							if (!Array.isArray(propertyValues.value[propDefId])) {
								propertyValues.value[propDefId] = [propertyValues.value[propDefId]]
							}
							propertyValues.value[propDefId].push(qp.propertyDefinitionValueId)
						} else {
							propertyValues.value[propDefId] = qp.propertyDefinitionValueId
						}
					} else if (qp.customValue !== null && qp.customValue !== undefined) {
						// BooleanCheckbox için boolean'a çevir
						if (propDef && propDef.displayType === 8) {
							propertyCustomValues.value[propDefId] = qp.customValue === 'true' || qp.customValue === true
						} else {
							propertyCustomValues.value[propDefId] = qp.customValue
						}
					}
				})
				
				// Multiple cardinality için array'e çevir ve başlangıç değerlerini ayarla
				propertyDefinitions.value.forEach(propDef => {
					if (propDef.cardinality === 2) {
						if (propertyValues.value[propDef.id]) {
							if (!Array.isArray(propertyValues.value[propDef.id])) {
								propertyMultipleValues[propDef.id] = [propertyValues.value[propDef.id]]
							} else {
								propertyMultipleValues[propDef.id] = propertyValues.value[propDef.id]
							}
							delete propertyValues.value[propDef.id]
						} else {
							// Başlangıçta boş array olarak initialize et
							if (!propertyMultipleValues[propDef.id]) {
								propertyMultipleValues[propDef.id] = []
							}
						}
					}
				})
			} catch (error) {
				// Hata loglama için global mekanizma tercih edilebilir
			}
		}

		const onPropertyChange = async (propertyDefinitionId, propertyValueId, customValue) => {
			if (!props.questionId) return
			
				// eslint-disable-next-line no-debugger
				debugger;
				
			try {
				internalLoading.value = true
				
				// undefined yerine null gönder, boş string'leri de kontrol et
				const requestData = {
					questionId: props.questionId,
					propertyDefinitionId: propertyDefinitionId,
					propertyDefinitionValueId: propertyValueId !== undefined && propertyValueId !== null ? propertyValueId : null,
					customValue: customValue !== undefined && customValue !== null && customValue !== '' ? customValue : null
				}
				
				console.log('[DEBUG] onPropertyChange - Request Data:', requestData)
				
				// eslint-disable-next-line no-debugger
				debugger;
				const result = await store.dispatch('postDatas', {
					api: 'QuestionProperties/upsert', 
					data: requestData
				})
				
				console.log('[DEBUG] onPropertyChange - Response:', result)
				
				if (result && result.result) {
					// Başarılı - property'leri yeniden yükle
					await getQuestionProperties(props.questionId)
				} else {
					console.error('[ERROR] onPropertyChange failed:', result)
				}
			} catch (error) {
				console.error('[ERROR] onPropertyChange exception:', error)
				if (error.response) {
					console.error('[ERROR] Response data:', error.response.data)
					console.error('[ERROR] Response status:', error.response.status)
				}
			} finally {
				internalLoading.value = false
			}
		}

	const onPropertyMultipleChange = async (propertyDefinitionId, valueId, event) => {
		// Çift tetiklemeyi önle: Eğer zaten bir işlem devam ediyorsa, yeni çağrıyı yoksay
		if (isProcessingMultipleChange.value) {
			console.log('[DEBUG] onPropertyMultipleChange - Zaten bir işlem devam ediyor, yoksayılıyor')
			return
		}
		
		console.log('[DEBUG] onPropertyMultipleChange CALLED:', {
			propertyDefinitionId,
			valueId,
			event,
			eventTarget: event?.target,
			eventTargetChecked: event?.target?.checked,
			questionId: props.questionId,
			currentArray: propertyMultipleValues[propertyDefinitionId]
		})
		
		if (!props.questionId) {
			console.warn('[WARN] questionId yok, işlem iptal')
			return
		}
		
		// Guard flag'i aktif et
		isProcessingMultipleChange.value = true
		
		// Checkbox'ın yeni durumu (checked / unchecked)
		// RCheckbox component'i event.target.checked'i doğru gönderiyor
		// Eğer event.target yoksa, v-model ile güncellenen array'i kontrol et
		let isChecked = false
		if (event && event.target && typeof event.target.checked === 'boolean') {
			isChecked = event.target.checked
		} else {
			// Fallback: v-model array'ini kontrol et
			const currentArray = propertyMultipleValues[propertyDefinitionId]
			if (Array.isArray(currentArray)) {
				isChecked = currentArray.includes(valueId) || currentArray.includes(String(valueId))
			}
		}
		
		console.log('[DEBUG] isChecked hesaplandı:', isChecked, {
			eventTargetChecked: event?.target?.checked,
			arrayIncludes: Array.isArray(propertyMultipleValues[propertyDefinitionId]) 
				? propertyMultipleValues[propertyDefinitionId].includes(valueId) 
				: false
		})
		
		try {
			internalLoading.value = true
			
			if (isChecked) {
				// CHECK → sadece bu value için upsert
				const requestData = {
					questionId: props.questionId,
					propertyDefinitionId: propertyDefinitionId,
					propertyDefinitionValueId: valueId !== undefined && valueId !== null ? valueId : null,
					customValue: null
				}
				
				console.log('[DEBUG] CHECK durumu - API çağrısı yapılıyor:', {
					api: 'QuestionProperties/upsert',
					requestData
				})
				
				const upsertResult = await store.dispatch('postDatas', {
					api: 'QuestionProperties/upsert',
					data: requestData
				})

				console.log('[DEBUG] Upsert API sonucu:', upsertResult)
				
				if (!upsertResult || !upsertResult.result) {
					console.warn(`[WARN] Failed to upsert property value ${valueId}`)
				} else {
					console.log('[SUCCESS] Property value başarıyla kaydedildi')
				}
			} else {
				// UNCHECK → sadece bu value için delete
				console.log('[DEBUG] UNCHECK durumu - DELETE API çağrısı yapılıyor:', {
					api: `QuestionProperties/delete/${props.questionId}/${propertyDefinitionId}/${valueId}`
				})
				
				const deleteResult = await store.dispatch('postDatas', {
					api: `QuestionProperties/delete/${props.questionId}/${propertyDefinitionId}/${valueId}`,
					data: {}
				})

				console.log('[DEBUG] Delete API sonucu:', deleteResult)
				
				if (!deleteResult || !deleteResult.result) {
					console.warn(`[WARN] Failed to delete property value ${valueId}`)
				} else {
					console.log('[SUCCESS] Property value başarıyla silindi')
				}
			}
		} catch (error) {
			console.error('[ERROR] Failed to save multiple properties:', error)
			if (error.response) {
				console.error('[ERROR] Response data:', error.response.data)
				console.error('[ERROR] Response status:', error.response.status)
				console.error('[ERROR] Response headers:', error.response.headers)
			}
			// Hata durumunda property'leri yeniden yükle
			await getQuestionProperties(props.questionId)
		} finally {
			internalLoading.value = false
			// Guard flag'i kapat (kısa bir gecikme ile çift tetiklemeyi tamamen önlemek için)
			setTimeout(() => {
				isProcessingMultipleChange.value = false
			}, 100)
		}
	}

		const onSelectChange = (propertyDefinitionId, e) => {
			const valueId = e && (e.val !== undefined ? e.val : e.id)
			onPropertyChange(propertyDefinitionId, valueId, null)
		}

		const onSingleCheckboxChange = (propertyDefinitionId, valueId) => {
			onPropertyChange(propertyDefinitionId, valueId, null)
		}

		// questionId değiştiğinde property'leri yeniden yükle
		watch(() => props.questionId, async (newId) => {
			if (newId) {
				await getQuestionProperties(newId)
			}
		}, { immediate: false })

		onMounted(async () => {
			// Önce property definitions'ları yükle
			await getPropertyDefinitions()
			
			// Sonra soruya ait property'leri yükle
			if (props.questionId) {
				await getQuestionProperties(props.questionId)
			}
		})

		const isLoadingComputed = computed(() => props.isLoading || internalLoading.value)

		return {
			propertyDefinitions,
			propertyValues,
			propertyMultipleValues,
			propertyCustomValues,
			showDebugInfo,
			isLoading: isLoadingComputed,
			onPropertyChange,
			onPropertyMultipleChange,
			onSelectChange,
			onSingleCheckboxChange
		}
	}
}
</script>

<style scoped>
.dynamic-property-fields-C {
	display: flex;
	flex-wrap: wrap;
	align-items: flex-end;
}
.dynamic-property-C {
	margin-right: 12px;
}
.dynamic-property-C label {
	font-size: 12px;
	color: #666;
	margin-bottom: 4px;
	display: block;
}
</style>

